import { makeGetRequest } from 'owa-ows-gateway';
import setSignatureInStore from '../actions/setSignatureInStore';
const HTML_SIGNATURE_URL =
    '/ows/beta/OutlookCloudSettings/settings/account?settingname=signaturehtml';
const TXT_SIGNATURE_URL =
    '/ows/beta/OutlookCloudSettings/settings/account?settingname=signaturetxt';

export default function loadRoamingSignature() {
    const signatureHtmlPromise = makeGetRequest(HTML_SIGNATURE_URL);
    const signatureTxtPromise = makeGetRequest(TXT_SIGNATURE_URL);
    return Promise.all([signatureHtmlPromise, signatureTxtPromise]).then(values => {
        const [signatureHtmlObj, signatureTxtObj] = values;
        let htmlSignature = '',
            txtSignature = '';

        if (signatureHtmlObj && signatureHtmlObj[0]?.value) {
            htmlSignature = signatureHtmlObj[0].value;
        }
        if (signatureTxtObj && signatureTxtObj[0]?.value) {
            txtSignature = signatureHtmlObj[0].value;
        }

        setSignatureInStore('html', htmlSignature);
        setSignatureInStore('txt', txtSignature);
    });
}
